import { render } from "./Destructor.vue?vue&type=template&id=5e89a418&scoped=true"
import script from "./Destructor.vue?vue&type=script&lang=js"
export * from "./Destructor.vue?vue&type=script&lang=js"

import "./Destructor.vue?vue&type=style&index=0&id=5e89a418&scoped=true&lang=css"

import exportComponent from "D:\\VueLearning\\SheepbaseVueJs\\SheepBaseVueApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e89a418"]])

export default __exports__